import { gql } from '@provision/graphql-client';
import { META_DATA_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import {
  NOTIFICATION_FRAGMENT,
  NOTIFICATION_RELATION_FRAGMENT,
} from './notification.fragments';

export const GET_NOTIFICATIONS_QUERY = gql`
  query GetNotification($params: QueryParams, $skipTotalRecords: Boolean = false)
  @entity(name: "Notification") {
    getNotification(queryParams: $params) {
      records {
        ...NotificationFields
        ...NotificationRelations
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${NOTIFICATION_FRAGMENT}
  ${NOTIFICATION_RELATION_FRAGMENT}
  ${META_DATA_QUERY_FIELDS}
`;

export const GET_NOTIFICATION_META_QUERY = gql`
  query GetNotificationMeta($params: QueryParams) {
    getNotification(queryParams: $params) {
      records {
        id
        entityId
        entity
      }
    }
  }
`;

export const UPDATE_NOTIFICATIONS_QUERY = gql`
  mutation UpdateNotification($conditions: [ConditionInput], $data: NotificationDataInput) {
    updateNotification(conditions: $conditions, data: $data) {
      ...NotificationFields
    }
  }
  ${NOTIFICATION_FRAGMENT}
`;
